module.exports = __webpack_public_path__ + "img/xian_b.f1e1d673.png";